/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Trips_Name_PlaceholderInputs */

const en_ui_trips_name_placeholder = /** @type {(inputs: Ui_Trips_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trip name`)
};

const de_ui_trips_name_placeholder = /** @type {(inputs: Ui_Trips_Name_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name der Tour`)
};

/**
* | output |
* | --- |
* | "Trip name" |
*
* @param {Ui_Trips_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_trips_name_placeholder = /** @type {((inputs?: Ui_Trips_Name_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Trips_Name_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_trips_name_placeholder(inputs)
	return de_ui_trips_name_placeholder(inputs)
});